const ar = {
  'INTEGRATIONS.ServiceNow.discovery.CONNECTIONNAME.title': 'اسم مصدر الاكتشاف',
  'INTEGRATIONS.ServiceNow.discovery.USERNAME.title': 'معرّف المُستخدِم',
  'INTEGRATIONS.ServiceNow.discovery.INSTANCENAME.title':
    'عنوان Url لـ Service Now',
  'INTEGRATIONS.ServiceNow.discovery.PASSWORD.title': 'كلمة المرور',
  'INTEGRATIONS.SERVICENOW.URL.VALIDATION_ERROR1': 'عنوان URL غير صالح',
  'INTEGRATIONS.LABEL.DISCOVERY_FREQUENCY': 'تكرار الاكتشاف',
  'INTEGRATIONS.DESCRIPTION.KBA_PROMPT':
    'مطالبة المستخدمين بالإجابة عن أسئلة المصادقة المستندة إلى المعرفة (KBA).',
  'INTEGRATIONS.DISCOVERY.DESCRIPTION':
    'اكتشاف التطبيقات وأعباء العمل من خلال أحد مصادر الاكتشاف الشائعة. ستحصل على مزايا مثل تعبئة البيانات تلقائيًا، وتوصيات مفضلة حسب الأولوية، وعرض كامل لحالة الإعداد.',
  'INTEGRATIONS.DISCOVERY.BACK': 'رجوع',
  'INTEGRATIONS.DISCOVERY.TITLE': 'إعداد الاكتشاف',
  'INTEGRATIONS.DISCOVERY.COMINGSOON': 'قريبًا...',
  'INTEGRATIONS.DISCOVERY.LEARNMORE': 'معرفة المزيد',
  'INTEGRATIONS.DISCOVERY.CONNECTION.APPLICATION.SETUP.DESCRIPTION':
    'قم بإدخال بيانات اعتماد التطبيق لإنشاء الاتصال. بمجرد نجاح الاتصال، ستتمكن من استيراد البيانات.',
  'INTEGRATIONS.DISCOVERY.ERROR.HEADING': 'حدث خطأ أثناء تحميل الصفحة.',
  'INTEGRATIONS.DISCOVERY.ERROR.SUBHEADING':
    'حاول التحديث، أو تحقق مرة أخرى لاحقًا. إذا استمرت المشكلة، فاتصل بالمسؤول الخاص بك.',
  'INTEGRATIONS.DISCOVERY.ERROR.RELOAD': 'إعادة تحميل',
  'INTEGRATIONS.ServiceNow.discovery.CONNECTION_SETTINGS.title':
    'إعدادات الاتصال',
  'INTEGRATIONS.ServiceNow.discovery.CI_CLASSES.title': 'فئات عنصر التكوين***',
  'INTEGRATIONS.ServiceNow.discovery.ATTRIBUTE_MAPPING.title': 'تعيين السمات',
  'INTEGRATIONS.Feature.Basic.ServiceNow.discovery.Conn.Title':
    'تفاصيل الاتصال',
  'INTEGRATIONS.BUTTON.SAVE': 'حفظ',
  'INTEGRATIONS.DISCOVERY.SELECT': 'تحديد',
  'INTEGRATIONS.DISCOVERY.CREATE_NEW_CONNECTION': 'إنشاء اتصال جديد',
  'INTEGRATIONS.DISCOVERY.USE_THIS_CONNECTION': 'استخدام هذا الاتصال',
  'INTEGRATIONS.DISCOVERY.SERVICENOW.SAVED': 'تم حفظ ServiceNow!',
  'INTEGRATIONS.DISCOVERY.SERVICENOW.SAVED.DESCRIPTION':
    'تم اختبار الاتصال بمصدر الاكتشاف ServiceNow بنجاح وتم حفظه. قم باستيراد البيانات لاستكمال إعداد الاكتشاف. يمكنك التخطي ...',
  'INTEGRATIONS.DISCOVERY.IMPORT': 'استيراد الأصول',
  'INTEGRATIONS.DISCOVERY.SKIP_FOR_NOW': 'تخطي الآن',
  'INTEGRATIONS.DISCOVERY.SERVICENOW.SAVED.INLINE':
    'بمجرد بدء الاستيراد، لا يمكن إلغاؤه',
  'INTEGRATION.DISCOVERY.SETUP.GUIDE_ME': 'أرشدني',
  'INTEGRATION.DISCOVERY.SELECT_EXISTING': 'اختيار اتصال موجود',
  'INTEGRATION.DISCOVERY.CONNECTION.NAME': 'اسم الاتصال',
  'INTEGRATION.EXISTING.CONNECTION.SUBTEXT':
    'لقد اكتشفنا {total, plural, one {} other {#}} من تكوينات الاتصال الموجودة:',
  'INTEGRATIONS.FILEUPLOAD.STARTIMPORT': 'بدء الاستيراد',
  'INTEGRATIONS.FILEUPLOAD.IMPORTINGDATA':
    'جارٍ استيراد البيانات من ملف Excel. يرجى الانتظار...',
  'INTEGRATIONS.TRY.AGAIN': 'المحاولة مرة أخرى',
  'INTEGRATIONS.CLOSE': 'إغلاق',
  'INTEGRATIONS.ERROR.CONNECTION': 'خطأ في الاتصال. يرجى المحاولة مرة أخرى.',
  'INTEGRATIONS.FILEUPLOAD.SUCCESS':
    'يمكنك الخروج من الصفحة أثناء الانتظار. سنخطرك بمجرد اكتمال العملية.',
  'INTEGRATIONS.FILEUPLOAD.MODAL.TITLE': 'استيراد مصدر الاكتشاف',
  'INTEGRATIONS.FILEUPLOAD.HEADING': 'استيراد مصدر الاكتشاف من ملف',
  'INTEGRATIONS.FILEUPLOAD.DOWNLOAD_SAMPLE': 'تنزيل ملف النموذج',
  'INTEGRATIONS.FILEUPLOAD.INPUT_LABEL': 'اسم مصدر الاكتشاف',
  'INTEGRATIONS.FILEUPLOAD.INPUT_PLACEHOLDER': 'إدخال اسم الملف',
  'INTEGRATIONS.FILEUPLOAD.INVALID_NAME':
    'يرجى إدخال اسم صالح. مسموح فقط باستخدام الحروف الأبجدية والأرقام وبعض الرموز المحددة.',
  'INTEGRATIONS.FILEUPLOAD.UPLOADING': 'جارٍ التحميل...',
  'INTEGRATIONS.FILEUPLOAD.CONTINUE': 'متابعة',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.TITLE':
    'إليك أول 10 سجلات من ملف XLSX الذي تم تحميله.',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.ALERT.MISSING_HEADER':
    'العنوان الإلزامي مفقود',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.ALERT.COLUMN_ERRORS_SUFFIX':
    'تم اكتشاف أخطاء في الأعمدة',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.ALERT.FIX_ISSUES':
    'يرجى إصلاح المشكلات قبل متابعة استيراد البيانات.',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.EXCLUDE': 'استثناء من الاستيراد',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.TITLE': 'تأكيد إعداد التطبيق',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.DESCRIPTION':
    'لقد حددنا نوع التطبيق. يرجى تأكيد ما إذا كان هذا نوع التطبيق الصحيح الذي تقوم بإعداده.',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.DEFAULT_APP_DESC':
    'نوع التطبيق الذي تقوم بإعداده هو {applicationName}',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.SELECT_DIFFERENT':
    'لا، حدد من قائمة التطبيقات',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.CONFIRM':
    'نعم، أقوم بإعداده حاليًا',
  'INTEGRATIONS.DASHBOARD.HEADER.TITLE': 'عمليات التكامل',
  'INTEGRATIONS.DASHBOARD.HEADER.ADD_INTEGRATION': 'إضافة تكامل',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.SEARCH': 'لم يتم العثور على نتائج لـ',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.FILTER': 'لا',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.FILTER.SUFFIX':
    'تم العثور على عمليات تكامل.',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.HIDDEN': 'لا تتوفر عمليات تكامل مخفية.',
  'INTEGRATIONS.DASHBOARD.APPLICATIONS_DISCOVERED': 'التطبيقات المكتشفة',
  'INTEGRATIONS.DASHBOARD.OWNER_LABEL': 'المالك:',
  'INTEGRATIONS.DASHBOARD.LAST_DISCOVERED': 'تم اكتشافه آخر مرة في',
  'INTEGRATIONS.DASHBOARD.CONNECTION_FAILED': 'تعذر الاتصال',
  'INTEGRATIONS.DASHBOARD.USERS_HAVE_ACCESS': 'المستخدمون لديهم حق الوصول',
  'INTEGRATIONS.DASHBOARD.CHIP_DISCOVERY_SOURCE': 'مصدر الاكتشاف',
  'INTEGRATIONS.BUTTON.ENABLE': 'تمكين',
  'INTEGRATIONS.BUTTON.DISABLE': 'تعطيل',
  'INTEGRATIONS.ENABLING': 'تمكين',
  'INTEGRATIONS.MODAL_TITLE.DISCOVERY': 'اكتشاف',
  'INTEGRATIONS.DASHBOARD.REUPLOAD': 'إعادة تحميل',
  'INTEGRATIONS.DASHBOARD.ONBOARD': 'إعداد',
  'INTEGRATIONS.DASHBOARD.HIDE': 'إخفاء',
  'INTEGRATIONS.DASHBOARD.UNHIDE': 'إظهار',
  'INTEGRATIONS.DISCOVERY.TABS_ARIA_LABEL': 'علامات تبويب تكوين الاكتشاف',
  'INTEGRATIONS.DISCOVERY.DISCARD_UNSAVED_CHANGES_TITLE':
    'هل تتجاهل التغييرات غير المحفوظة؟',
  'INTEGRATIONS.DISCOVERY.DISCARD_UNSAVED_CHANGES_SUBTITLE':
    'لديك تغييرات غير محفوظة. سيتم فقدان التغييرات إذا واصلت.',
  'INTEGRATIONS.BUTTON.DISCARD_CHANGES': 'تجاهل التغييرات',
  'INTEGRATIONS.BUTTON.CANCEL': 'إلغاء',
  'INTEGRATIONS.BUTTON.SAVE_ERROR_TITLE': 'حفظ الخطأ',
  'INTEGRATIONS.CMDB_HEADER.BACK_BUTTON_ARIA_LABEL':
    'العودة إلى الصفحة السابقة',
  'INTEGRATIONS.CMDB_HEADER.IMAGE_ALT': 'أيقونة التطبيق',
  'INTEGRATIONS.CMDB_HEADER.RUN_MANUALLY_BUTTON': 'التشغيل يدويًا',
  'INTEGRATIONS.CMDB_HEADER.ALERT.DISABLE_FAILED_TITLE': 'فشل التعطيل',
  'INTEGRATIONS.CMDB_HEADER.ALERT.ENABLE_FAILED_TITLE': 'فشل التمكين',
  'INTEGRATIONS.CMDB_HEADER.ALERT.DISABLE_SUCCESS_DESCRIPTION':
    'تم التعطيل بنجاح.',
  'INTEGRATIONS.CMDB_HEADER.ALERT.ENABLE_SUCCESS_DESCRIPTION':
    'تم التمكين بنجاح.',
  'INTEGRATION.DISCOVERY.SETUP.SERVICENOW.JOBCONFLICT':
    'هناك عملية استيراد أخرى قيد التنفيذ حاليًا.',
  'INTEGRATION.DISCOVERY.SETUP.SERVICENOW.JOBCONFLICT.SUBHEADING':
    'يتم حاليًا استيراد الأصول بواسطة عملية أخرى. يُرجى إعادة المحاولة لاحقًا.',
  'INTEGRATION.DISCOVERY.SETUP.SERVICENOW.IMPORTFAILED': 'فشل الاستيراد',
  'INTEGRATIONS.DISCOVERY.IMPORTINGASSETS': 'استيراد الأصول من ServiceNow',
  'INTEGRATIONS.DISCOVERY.IMPORTINGASSETS.MESSAGE':
    'يمكنك الخروج من الصفحة أثناء الانتظار. سنخطرك بمجرد اكتمال العملية.',
  'INTEGRATIONS.ATTRIBUTE_MAPPINGS.BUTTON.ADD_ROW_ARIA_LABEL':
    'إضافة صف تعيين سمة جديد',
  'INTEGRATIONS.ATTRIBUTE_MAPPINGS.BUTTON.ADD_ATTRIBUTE': 'إضافة سمة',
  'INTEGRATIONS.ATTRIBUTE_ROW.EMPTY_PLACEHOLDER': '(فارغ)',
  'INTEGRATIONS.ATTRIBUTE_ROW.DELETE_ARIA_LABEL': 'حذف هذا التعيين',
  'INTEGRATIONS.ATTRIBUTE_ROW.HEADER.SERVICENOW_FIELD': 'حقل ServiceNow',
  'INTEGRATIONS.ATTRIBUTE_ROW.HEADER.SAVIYNT_FIELD': 'حقل Saviynt',
  'INTEGRATIONS.ATTRIBUTE_DROPDOWN.SEARCH_SERVICENOW':
    'البحث عن سمة ServiceNow',
  'INTEGRATIONS.ATTRIBUTE_DROPDOWN.SEARCH_SAVIYNT': 'البحث عن سمة Saviynt',
  'INTEGRATIONS.ATTRIBUTE_DROPDOWN.CUSTOM_SUFFIX': '(تخصيص)',
  'INTEGRATIONS.ERROR.SAVE_FAILED': 'فشل الحفظ',
  'INTEGRATIONS.SCHEDULING.ARIA_LABEL': 'تكوين الجدولة',
  'INTEGRATIONS.SCHEDULING.REPEATS_AT':
    'في {timeLabel} بالتوقيت العالمي المنسق.',
  'INTEGRATIONS.SCHEDULING.REPEAT_ON_TITLE': 'التكرار على',
  'INTEGRATIONS.SCHEDULING.REPEAT_ON_DAYS_GROUP': 'التكرار على أيام',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.LABEL.REPEAT_EVERY': 'التكرار كل',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.PLACEHOLDER.ENTER_INTERVAL':
    'أدخل الفاصل الزمني',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.ARIA_LABEL.REPEAT_INTERVAL':
    'كرر الفاصل الزمني بعدد الأيام أو الأسابيع أو الأشهر',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.UNIT.DAY': 'يوم',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.UNIT.WEEK': 'أسبوع',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.UNIT.MONTH': 'شهر',
  'INTEGRATIONS.DAYS.SUN': 'الأحد',
  'INTEGRATIONS.DAYS.MON': 'الاثنين',
  'INTEGRATIONS.DAYS.TUE': 'الثلاثاء',
  'INTEGRATIONS.DAYS.WED': 'الأربعاء',
  'INTEGRATIONS.DAYS.THU': 'الخميس',
  'INTEGRATIONS.DAYS.FRI': 'الجمعة',
  'INTEGRATIONS.DAYS.SAT': 'السبت',
  'INTEGRATIONS.BUTTON.DISABLING': 'تعطيل',
  'INTEGRATIONS.BUTTON.SAVED': 'تم الحفظ',
  'INTEGRATIONS.BUTTON.SAVING': 'حفظ',
  'INTEGRATIONS.DISABLE_MODAL.ALERT_TITLE': 'هل تريد بالتأكيد التعطيل ',
  'INTEGRATIONS.DISABLE_MODAL.ALERT_SUBTITLE':
    'من خلال تعطيل مصدر الاكتشاف، سيتم إيقاف استيراد الأصول ولن تتمكن من تكوين المصدر.',
  'INTEGRATIONS.DISCOVERY.HERE': 'هنا',
  'INTEGRATIONS.DISCOVERY.EXISTING.CONNECTION.FAILED':
    'لقد تم إنشاء مصدر الاكتشاف الخاص بك بنجاح، ولكن فشل الاتصال بـ ServiceNow. لبدء استيراد الأصول، يُرجى تحديث تفاصيل الاتصال على صفحة تكوين مصدر الاكتشاف ',
};

export default ar;
